<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
    name: "App"
};
</script>

<style> 
html,
body {
    min-width: 1440px;
    font-size: 14px;
    font-weight: 500;
    height: 100%;
    overflow-x: auto;
    color: #595959;
    box-sizing: border-box;
    padding: 0px;
    margin: 0px;
    background-color: #f0f2f5;
}
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    widows: 100%;
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue